function hexToRgb(hex) {
  const h = (hex || "").replace("#", "");
  return [0, 2, 4].map((i) => parseInt(h.slice(i, i + 2), 16) || 0);
}

function toHex([r, g, b]) {
  return `#${[r, g, b].map((x) => Math.max(0, Math.min(255, Math.round(x))).toString(16).padStart(2, "0")).join("")}`;
}

function mix(hex, target, amt) {
  const [r, g, b] = hexToRgb(hex);
  return toHex([r + (target[0] - r) * amt, g + (target[1] - g) * amt, b + (target[2] - b) * amt]);
}

const WHITE = [255, 255, 255];
const BLACK = [0, 0, 0];

// Build a cohesive badge palette (bg/border/text/dot) from a single base hex color.
export function styleFromBase(hex) {
  return {
    bg: mix(hex, WHITE, 0.88),
    border: mix(hex, WHITE, 0.62),
    text: mix(hex, BLACK, 0.32),
    dot: hex,
  };
}
